<template>
  <div class="notifications">
    <div v-if="notificationsSupported">
      <p>Note: this is experimental. Sign up here to receive a reminder to track your activities at 8pm mountain time.</p>
      <label class="toggleLabel">
        <div class="switch">
          <input type="checkbox" v-model="checked" @change="toggleSubscription">
          <span class="slider round"></span>
        </div>
        <div class="text">Subscribe to daily notifications</div>
      </label>
    </div>
    <div v-if="!notificationsSupported">
      Your device does not support notifications.
    </div>
  </div>
</template>

<script>
import DataUser from '@/data/controllers/DataUser'

export default {
  name: 'Notification',
  data () {
    return {
      checkedProxy: false,
      serviceWorkerRegistration: false,
      notificationsSupported: false
    }
  },
  computed: {
    checked: {
      get () {
        return this.checkedProxy
      },
      set (newValue) {
        this.checkedProxy = newValue
      }
    }
  },
  created () {
    if ('Notification' in window && 'serviceWorker' in navigator) {
      this.notificationsSupported = true
    }
  },
  mounted () {
    this.findSubscription()
      .then(sub => {
        if (sub === null) {
          this.buttonDisabled = false
          this.notificationsEnabled = false
        } else {
          // retrieve user info from API
          this.buttonDisabled = false
          this.notificationsEnabled = true
          this.subscription = sub
          this.checked = true
        }
      })
  },
  methods: {
    requestPermission () {
      if (Notification) {
        Notification.requestPermission(function (status) {
          console.log('Notification permission status:', status)
        })
      }
    },
    urlBase64ToUint8Array (base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4)
      const base64 = (base64String + padding)
        // .replace(/\-/g, '+')
        .replace(/-/g, '+')
        .replace(/_/g, '/')
      const rawData = window.atob(base64)
      let outputArray = new Uint8Array(rawData.length)
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    },
    findSubscription () {
      return navigator.serviceWorker.ready
        .then(swreg => {
          this.serviceWorkerRegistration = swreg
          return this.getSubscription(this.serviceWorkerRegistration)
        })
    },
    getSubscription (swreg) {
      return swreg.pushManager.getSubscription()
    },
    subscribe (swreg) {
      // create new subscription for this browser on this device
      const vapidPublicKey = 'BGitrL5UDBQs8clkH2zx4g4NHBoOG2LhPmrIvRF0XyECfcsAA7EuMnW/TQfNjtbSlvqxRcJs0ZjPuDQkwH+myJ0='
      const convertedVapidPublicKey = this.urlBase64ToUint8Array(vapidPublicKey)
      // return the subscription promise, we chain another then where we can send it to the server
      return swreg.pushManager.subscribe({
        userVisibleOnly: true,
        // This is for security. On the backend, we need to do something with the VAPID_PRIVATE_KEY
        // that you can find in .env to make this work in the end
        applicationServerKey: convertedVapidPublicKey
      })
    },
    toggleSubscription () {
      if (this.notificationsSupported) {
        // Find out if we need to create a subscription or delete it
        if (this.checked) {
          // Ask permission and when granted, create new subscription

          Notification.requestPermission()
            .then(result => {
              // if granted, create new subscription
              if (result === 'granted') {
                this.createSubscription()
                  .then(sub => {
                    this.subscription = sub

                    // store new subscription on the server
                    // this.$apidata.notificationSubscribe(sub)
                    DataUser.notificationSubscribe(sub)
                    this.notificationsEnabled = true
                  })
              } else {
                console.log('User did not grant permission')
              }
            })
        } else {
          // Destroy subscription
          if (this.subscription !== null) {
            // destroy on the server
            // return this.$apidata.notificationUnsubscribe(this.subscription.endpoint)
            return DataUser.notificationUnsubscribe(this.subscription.endpoint)
              // unsubscribe on the client
              .then(() => this.subscription.unsubscribe())
              .then(() => {
                // update the data
                this.notificationsEnabled = false
                this.subscription = null
              })
          }
        }
      }
    },
    createSubscription () {
      if (this.serviceWorkerRegistration === null) {
        return navigator.serviceWorker.ready // returns a Promise, the active SW registration
          .then(swreg => {
            this.serviceWorkerRegistration = swreg
            return this.subscribe(this.serviceWorkerRegistration)
          })
      } else {
        return this.subscribe(this.serviceWorkerRegistration)
      }
    },
    checkSubscription () {
      return navigator.serviceWorker.ready
        .then(swreg => {
          console.log(swreg)
          // console.log(swreg.PushManager.getSubscription())
        })
    }
  }
}
</script>

<style>
  .notifications label.toggleLabel .text {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/Notification.vue